export const mockMetrics = [
  { id: 1, title: 'Primas Activas', value: '$124,500', trend: '+12%', isUp: true },
  { id: 1, title: 'Primas Activas', value: '$124.500.000', trend: '+12%', isUp: true },
  { id: 2, title: 'Pólizas Nuevas (Mes)', value: '84', trend: '+5%', isUp: true },
  { id: 3, title: 'Tasa de Conversión', value: '28%', trend: '-2%', isUp: false },
  { id: 4, title: 'Renovaciones Pendientes', value: '12', trend: '30 días', isUp: true },
];

export const mockPolicies = [
  { id: 'POL-1001', clientName: 'Juan Pérez', type: 'Auto', value: '$350.000/año', stage: 'active', date: '12 Ene 2026', phone: '+56 9 1234 5678' },
  { id: 'POL-1002', clientName: 'Empresa XYZ', type: 'Flota', value: '$4.500.000/año', stage: 'renewal', date: '05 Feb 2026', phone: '+56 9 8765 4321' },
  { id: 'POL-1003', clientName: 'María González', type: 'Vida', value: '$850.000/año', stage: 'underwriting', date: '28 Feb 2026', phone: '+56 9 1122 3344' },
  { id: 'POL-1004', clientName: 'Carlos Ruiz', type: 'Hogar', value: '$220.000/año', stage: 'quoted', date: '02 Mar 2026', phone: '+56 9 5566 7788' },
  { id: 'POL-1005', clientName: 'Ana Silva', type: 'Salud', value: '$1.250.000/año', stage: 'lead', date: '10 Mar 2026', phone: '+56 9 9988 7766' },
];

export const kanbanStages = [
  { id: 'lead', title: 'Prospecto' },
  { id: 'quoted', title: 'Cotizado' },
  { id: 'underwriting', title: 'En Suscripción' },
  { id: 'active', title: 'Póliza Activa' },
  { id: 'renewal', title: 'Renovación' }
];

export const mockActivities = [
  { id: 1, text: 'Juan (Admin) movió la póliza POL-1004 a En Suscripción.', time: 'Hace 30 mins' },
  { id: 2, text: 'Corredor (Editor) envió un email a Carlos Ruiz.', time: 'Hace 2 horas' },
  { id: 3, text: 'Nuevo lead automático recibido desde el formulario público.', time: 'Hace 5 horas' },
  { id: 4, text: 'Auditor (Viewer) revisó el historial de la póliza POL-1002.', time: 'Ayer' },
  { id: 5, text: 'Póliza POL-1001 de Auto generó recordatorio de renovación.', time: 'Ayer' }
];
